module.exports = __webpack_public_path__ + "static/media/MicrophoneCheck.e358824e.png";